import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ctk8411a4a: FaireBrandEntity = {
  token: "b_ctk8411a4a",
  type: "brand",
  name: "Thistle Farms",
  avatarUrl:
    "https://cdn.faire.com/fastly/51d3ffcb6920f184204f748fe62a3764fa64e53866a2a21bc79e964887637e41.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/cb4a30fd9490484f3f9ce0fbb42fcd2d5afec9ed27f1158212ea97d91156e0e2.png",
  logoUrl:
    "https://cdn.faire.com/fastly/51d3ffcb6920f184204f748fe62a3764fa64e53866a2a21bc79e964887637e41.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cb4a30fd9490484f3f9ce0fbb42fcd2d5afec9ed27f1158212ea97d91156e0e2.png",
  location: "Nashville, TN, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 78,
  isTopShop: true,
  isInsider: true,
  description:
    "Thistle Farms: rebuilding lives, empowering women through candles, essential oils, and home goods. \n\nWe help resilient women survivors overcome unimaginable hardships. As a nonprofit social enterprise, we provide safe havens for healing, combining secure housing, meaningful employment, and lifelong sisterhood. Traumatic experiences drive these women to addiction and prostitution and with love and support, we believe they can thrive.\n\nOur products are naturally handcrafted and with each purchase you help provide safe housing, healthcare, therapy, and dignified employment to women survivors.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:34.275Z",
    importedBy: "entity-db-cli",
  },
};
